<ns-grid
  class="d-flex flex-column h-100"
  [name]="name"
  rowSelection="multiple"
  [gridTitle]="title"
  [gridOptions]="gridOptions"
  [data]="reservations"
  [loading]="loading"
  [resizeType]="resizeType"
  [config]="config"
  (refresh)="reload.emit()">
</ns-grid>
